import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<string[]>([]);
  public breadcrumbs$ = this.breadcrumbsSubject.asObservable();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const breadcrumbs: string[] = [];
      this.collectBreadcrumbs(this.activatedRoute.root, breadcrumbs);
      this.breadcrumbsSubject.next(breadcrumbs);
    });
  }

  private collectBreadcrumbs(route: ActivatedRoute, breadcrumbs: string[]) {
    const snapshot = route.snapshot;

    if (snapshot.routeConfig && snapshot.data['breadcrumb']) {
      const label = snapshot.data['breadcrumb'];
      // Only push if it's not the same as the last breadcrumb
      if (breadcrumbs[breadcrumbs.length - 1] !== label) {
        breadcrumbs.push(label);
      }
    }

    route.children.forEach((child) => this.collectBreadcrumbs(child, breadcrumbs));
  }
}
